import { App } from './app';

export class Invitation {
  companyId?: string;
  id?: string;
  email: string;
  apps?: App[];
  dateInvited?: string;
  userMessage?: string;
  inviteFrom?: string;
  signupUrl?: string;
  appName?: string;
  isCompanyManager?: boolean;
  branchAssignments: Branch[];
  companyAccountId?: string;
  companyName?: string;
}

export class Branch {
  name: string;
  accountId: string;
}
